import {
  IArticlesFixedTranslationsKeys,
  ISurveysFixedTranslationsKeys,
  ITranslationResponse,
} from "../@types/Translations";

export const parseSurveyTranslationResponseToDisplay = (
  translationsArray: ITranslationResponse[]
): ISurveysFixedTranslationsKeys => {
  const resources: ISurveysFixedTranslationsKeys = {
    survey_fixed_translations_survey_navigation_start: "",
    survey_fixed_translations_survey_navigation_next: "",
    survey_fixed_translations_survey_navigation_previous: "",
    survey_fixed_translations_survey_navigation_submit: "",
    survey_fixed_translations_survey_navigation_upload: "",
    survey_fixed_translations_survey_navigation_skip: "",
    survey_fixed_translations_five_questions_question_one_description: "",
    survey_fixed_translations_five_questions_question_one_option_one: "",
    survey_fixed_translations_five_questions_question_one_option_two: "",
    survey_fixed_translations_five_questions_question_two_description: "",
    survey_fixed_translations_five_questions_question_two_option_one: "",
    survey_fixed_translations_five_questions_question_two_option_two: "",
    survey_fixed_translations_five_questions_question_two_option_three: "",
    survey_fixed_translations_five_questions_question_two_option_four: "",
    survey_fixed_translations_five_questions_question_three_description: "",
    survey_fixed_translations_five_questions_question_four_description: "",
    survey_fixed_translations_five_questions_question_five_description: "",
    survey_fixed_translations_media_question_error_size: "",
    survey_fixed_translations_media_question_error_api: "",
    survey_fixed_translations_media_question_error_network: "",
    survey_fixed_translations_media_question_success: "",
    survey_fixed_translations_media_question_warning_blurry: "",
    survey_fixed_translations_media_question_error_video_size: "",
    survey_fixed_translations_media_question_error_unsupported_type: "",
    survey_fixed_translations_media_question_attach: "",
    survey_fixed_translations_media_question_attach_more: "",
    survey_fixed_translations_media_question_error_max_files: "",
  };

  translationsArray.forEach((translation: ITranslationResponse) => {
    resources[translation.key as keyof typeof resources] = translation.value;
  });

  return resources;
};

export const parseArticlesTranslationResponseToDisplay = (
  translationsArray: ITranslationResponse[]
): IArticlesFixedTranslationsKeys => {
  const resources: IArticlesFixedTranslationsKeys = {
    articles_fixed_translations_view_all_articles: "",
    articles_fixed_translations_other_articles: "",
  };

  translationsArray.forEach((translation: ITranslationResponse) => {
    resources[translation.key as keyof typeof resources] = translation.value;
  });

  return resources;
};

/**
 * EN-5191: turns the portal's API rows into the resource object i18next expects.
 *
 * The portal's keys are flat, underscore-separated paths ("patientList_columns_name") and
 * i18next is initialised with `keySeparator: false`, so a row maps straight to an entry —
 * there is no tree to rebuild. A row with no key is skipped; a duplicate key keeps the last
 * row, which is what an upsert-backed table would return anyway.
 */
export const parsePortalTranslationsToResources = (
  translationsArray: ITranslationResponse[]
): Record<string, string> => {
  const resources: Record<string, string> = {};

  translationsArray.forEach(({ key, value }) => {
    if (!key) return;
    resources[key] = value;
  });

  return resources;
};
